import { render } from "./Footer.vue?vue&type=template&id=2de1ecfa&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=2de1ecfa&lang=less&scoped=true"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de1ecfa"]])

export default __exports__